<template>
  <div class="form-group form-group--intl-phone-input">
    <n-input v-bind="$attrs" v-model="telNational" type="tel" inputmode="tel" autocomplete="tel-national" phone-number class="mb-0">
      <n-searchable-select slot="prepend" v-model="selectedCountry" tabindex="-1" :items="countries" item-label-prop="name" item-key-prop="iso" :selected-item-label="item => `${item.unicode} +${item.dial}`" :filter-predicate="filterCountries" label="Country" autocomplete="tel-country-code" class="country-code-picker">
        <template slot="list-item" slot-scope="{item}">
          <small>{{item.unicode}} {{item.name}}</small>
        </template>
      </n-searchable-select>
      <slot name="label" slot="label" slot-scope="{label}" :label="label"></slot> <!-- forward label slot content to <n-input>'s label slot -->
      <slot name="help" slot="help"></slot> <!-- forward slot content to <n-input>'s slot -->
      <slot name="prepend" slot="prepend"></slot> <!-- forward slot content to <n-input>'s slot -->
      <slot name="append" slot="append"></slot> <!-- forward slot content to <n-input>'s slot -->
      <slot name="default" slot="default"></slot> <!-- forward default slot content to <n-input>'s default slot -->
    </n-input>
  </div>
</template>

<script>
  import { countries } from '../../utils/intl-utils'

  export default {

    props: {
      value: { type: String },
      defaultCountry: { type: String, required: true }, // the default country to select (by iso code)
    },

    data() {
      return {
        telNational: '',
        selectedCountry: countries.find(country => country.iso == this.defaultCountry.toUpperCase() ),
        countries,
      }
    },

    computed: {
      fullTelNumber() {
        return `+${this.selectedCountry.dial}${this.telNational}`
      },
    },

    watch: {
      value: {
        handler() {
          if(this.value) {
            let sanitised = this.value.split('+').pop()
            let dialCode = this.selectedCountry.dial
            sanitised.includes(dialCode)
              ? this.telNational = sanitised.replace(new RegExp(`^${dialCode}`), '')
              : this.telNational = sanitised
          }
          else {
            this.telNational = ''
          }
        },
        immediate: true
      },

      fullTelNumber() {
        this.$emit('input', this.fullTelNumber)
      },
    },

    methods: {
      filterCountries(list, query) {
        return list.filter(country => country.name.toLowerCase().includes(query) || country.dial.startsWith(query.replace(/\+/g, '')))
      },
    },
  }
</script>